var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import Button from "@gcp-artifact/compass/lib/components/updated/button";
import translate from "@/utilities/i18n/getTranslate";
import { k } from "@/utilities/i18n";
import TaxIdField from "./TaxIdField";
import useSaveTaxId from "./useSaveTaxId";
import * as Styled from "./TaxIdStyles";
/**
 * Collects the tax id (CPF/CNPJ) as a step inside an existing payment dialog,
 * so the user never loses the payment they started.
 */
var TaxIdStep = function (_a) {
    var onBack = _a.onBack, onSaved = _a.onSaved;
    var _b = __read(React.useState(""), 2), taxId = _b[0], setTaxId = _b[1];
    var _c = useSaveTaxId(), saveTaxId = _c.saveTaxId, isSaving = _c.isSaving;
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var saved;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, saveTaxId(taxId)];
                case 1:
                    saved = _a.sent();
                    if (saved)
                        onSaved();
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(Styled.TaxIdStepContainer, null,
        React.createElement(TaxIdField, { value: taxId, onChange: setTaxId, disabled: isSaving }),
        React.createElement(Styled.ActionRow, null,
            React.createElement(Button, { variant: "secondary", size: "small", onClick: onBack, disabled: isSaving, margin: "0" }, translate(k.A_back)),
            React.createElement(Button, { variant: "primary", size: "small", type: "submit", isPending: isSaving, disabled: !taxId.trim(), onClick: handleSave, margin: "0" }, translate(k.BILL_saveAndContinue)))));
};
export default TaxIdStep;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGF4SWRTdGVwLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiVGF4SWRTdGVwLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsT0FBTyxLQUFLLE1BQU0sT0FBTyxDQUFDO0FBQzFCLE9BQU8sTUFBTSxNQUFNLHFEQUFxRCxDQUFDO0FBRXpFLE9BQU8sU0FBUyxNQUFNLCtCQUErQixDQUFDO0FBQ3RELE9BQU8sRUFBRSxDQUFDLEVBQUUsTUFBTSxrQkFBa0IsQ0FBQztBQUNyQyxPQUFPLFVBQVUsTUFBTSxjQUFjLENBQUM7QUFDdEMsT0FBTyxZQUFZLE1BQU0sZ0JBQWdCLENBQUM7QUFDMUMsT0FBTyxLQUFLLE1BQU0sTUFBTSxlQUFlLENBQUM7QUFPeEM7OztHQUdHO0FBQ0gsSUFBTSxTQUFTLEdBQXlCLFVBQUMsRUFBbUI7UUFBakIsTUFBTSxZQUFBLEVBQUUsT0FBTyxhQUFBO0lBQ2xELElBQUEsS0FBQSxPQUFvQixLQUFLLENBQUMsUUFBUSxDQUFDLEVBQUUsQ0FBQyxJQUFBLEVBQXJDLEtBQUssUUFBQSxFQUFFLFFBQVEsUUFBc0IsQ0FBQztJQUN2QyxJQUFBLEtBQTBCLFlBQVksRUFBRSxFQUF0QyxTQUFTLGVBQUEsRUFBRSxRQUFRLGNBQW1CLENBQUM7SUFFL0MsSUFBTSxVQUFVLEdBQUc7Ozs7d0JBQ0gscUJBQU0sU0FBUyxDQUFDLEtBQUssQ0FBQyxFQUFBOztvQkFBOUIsS0FBSyxHQUFHLFNBQXNCO29CQUNwQyxJQUFJLEtBQUs7d0JBQUUsT0FBTyxFQUFFLENBQUM7Ozs7U0FDdEIsQ0FBQztJQUVGLE9BQU8sQ0FDTCxvQkFBQyxNQUFNLENBQUMsa0JBQWtCO1FBQ3hCLG9CQUFDLFVBQVUsSUFBQyxLQUFLLEVBQUUsS0FBSyxFQUFFLFFBQVEsRUFBRSxRQUFRLEVBQUUsUUFBUSxFQUFFLFFBQVEsR0FBSTtRQUNwRSxvQkFBQyxNQUFNLENBQUMsU0FBUztZQUNmLG9CQUFDLE1BQU0sSUFDTCxPQUFPLEVBQUMsV0FBVyxFQUNuQixJQUFJLEVBQUMsT0FBTyxFQUNaLE9BQU8sRUFBRSxNQUFNLEVBQ2YsUUFBUSxFQUFFLFFBQVEsRUFDbEIsTUFBTSxFQUFDLEdBQUcsSUFFVCxTQUFTLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxDQUNiO1lBQ1Qsb0JBQUMsTUFBTSxJQUNMLE9BQU8sRUFBQyxTQUFTLEVBQ2pCLElBQUksRUFBQyxPQUFPLEVBQ1osSUFBSSxFQUFDLFFBQVEsRUFDYixTQUFTLEVBQUUsUUFBUSxFQUNuQixRQUFRLEVBQUUsQ0FBQyxLQUFLLENBQUMsSUFBSSxFQUFFLEVBQ3ZCLE9BQU8sRUFBRSxVQUFVLEVBQ25CLE1BQU0sRUFBQyxHQUFHLElBRVQsU0FBUyxDQUFDLENBQUMsQ0FBQyxvQkFBb0IsQ0FBQyxDQUMzQixDQUNRLENBQ08sQ0FDN0IsQ0FBQztBQUNKLENBQUMsQ0FBQztBQUVGLGVBQWUsU0FBUyxDQUFDIn0=